import { create, all } from 'mathjs';
import { delocalizeDecimalSeparator } from 'sharedreact/utils/LanguageSupport';

const math = create(all);

function isPercentage (valueString: string): boolean {
  try {
    let value: string = delocalizeDecimalSeparator(valueString);
    value = value.replace(/[%\s]/g, '');
    math.number(value);

    return true;
  } catch (e) {
    return false;
  }
}

const PercentageValidators = {
  isPercentage
};

export {
  isPercentage
};

export default PercentageValidators;